import createVueApp from '@phoenix/createVueApp';
import ContentSlider from '@maison/components/organisms/slider/ContentSlider.vue';

document.querySelectorAll('.phoenix-content-slider').forEach((el) => {
  const app = createVueApp();
  app.component('ContentSlider', ContentSlider);
  app.mount(el);
});
